module.exports = __webpack_public_path__ + "img/plus.844f65cb.svg";